import { FormControl } from '@angular/forms';

export class Enquiry {

    Name: string;
    Email: string;
    Phone: string;
    Company: string;
    JobTitle?: string;
    Subject: string;
    FinesseSelected: boolean;
    FiscalSelected: boolean;
    AbacusSelected: boolean;
    PortalSelected: boolean;
    ServiceSelected: boolean;
    OtherSelected: boolean;
    Body: string;
    Captcha: string;

    constructor(
        name: string,
        email: string,
        phone: string,
        company: string,
        jobTitle: string,
        subject: string,
        finesseSelected: boolean,
        fiscalSelected: boolean,
        abacusSelected: boolean,
        portalSelected: boolean,
        serviceSelected: boolean,
        otherSelected: boolean,
        body: string,
        captcha: string
    ) {
        this.Name = name;
        this.Email = email;
        this.Phone = phone;
        this.Company = company;
        this.JobTitle = jobTitle;
        this.Subject = subject;
        this.FinesseSelected = finesseSelected;
        this.FiscalSelected = fiscalSelected;
        this.AbacusSelected = abacusSelected;
        this.PortalSelected = portalSelected;
        this.ServiceSelected = serviceSelected;
        this.OtherSelected = otherSelected;
        this.Captcha = captcha;
    }
    


}

export class GlobalValidator {

    static validateEmail(c: FormControl) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    return EMAIL_REGEXP.test(c.value) ? null : {
        validateEmail: {
            valid: false
        }
    };
}
}





/** WEBPACK FOOTER **
 ** ./src/app/model.ts
 **/